{
  "level": "subpath",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:subpath",
    "objects": "AREAS.E3:subpath.e3",
    "mesh": "TREES.E3:subpath.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -984.0,
      "bbox_min": [
        -4447.5,
        -5212.5,
        865.0
      ],
      "bbox_max": [
        -3218.0,
        -3318.5,
        1003.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -919.0,
      "bbox_min": [
        -4447.5,
        -5212.5,
        865.0
      ],
      "bbox_max": [
        -3218.0,
        -4592.5,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -875.2000122070312,
      "bbox_min": [
        -4265.2998046875,
        -5212.5,
        865.0
      ],
      "bbox_max": [
        -3400.699951171875,
        -5158.5,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -869.0,
      "bbox_min": [
        -3832.5,
        -5212.5,
        865.0
      ],
      "bbox_max": [
        -3583.10009765625,
        -5207.2998046875,
        869.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -865.0,
      "bbox_min": [
        -3832.5,
        -5212.5,
        865.0
      ],
      "bbox_max": [
        -3827.5,
        -5207.5,
        865.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -895.0,
      "bbox_min": [
        -4265.2998046875,
        -5163.5498046875,
        889.0
      ],
      "bbox_max": [
        -3400.699951171875,
        -5158.5,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -889.0,
      "bbox_min": [
        -3405.699951171875,
        -5163.5498046875,
        889.0
      ],
      "bbox_max": [
        -3400.699951171875,
        -5158.5498046875,
        889.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -953.0,
      "bbox_min": [
        -4447.5,
        -5029.5,
        935.0
      ],
      "bbox_max": [
        -3218.0,
        -4592.5,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -935.0,
      "bbox_min": [
        -4398.5,
        -5029.5,
        935.0
      ],
      "bbox_max": [
        -4393.5,
        -5024.5,
        935.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -955.0,
      "bbox_min": [
        -4447.5,
        -4847.0,
        955.0
      ],
      "bbox_max": [
        -4442.0,
        -4592.5,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -965.0,
      "bbox_min": [
        -4447.5,
        -4597.5,
        965.0
      ],
      "bbox_max": [
        -4442.5,
        -4592.5,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -985.75,
      "bbox_min": [
        -4447.35009765625,
        -4474.5,
        985.0
      ],
      "bbox_max": [
        -3218.0,
        -3318.5,
        1003.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -985.0,
      "bbox_min": [
        -4407.35009765625,
        -4007.25,
        985.0
      ],
      "bbox_max": [
        -4202.0,
        -3353.10009765625,
        985.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1003.7999877929688,
      "bbox_min": [
        -4025.0,
        -4474.5,
        995.0
      ],
      "bbox_max": [
        -3218.0,
        -3318.5,
        1003.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -995.0,
      "bbox_min": [
        -4025.0,
        -3323.699951171875,
        995.0
      ],
      "bbox_max": [
        -3909.300048828125,
        -3318.5,
        995.0
      ],
      "face_count": 2
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}